var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAutobid = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.25,
  fill: "white",
  stroke: "#378CCB",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.2998 16H14.3688L13.8651 14.6447H10.4348L9.93103 16H8L11.0825 8H13.2174L16.2998 16ZM13.3973 13.1454L12.1499 9.70315L10.9025 13.1454H13.3973Z",
  fill: "#378CCB"
})));
export default SvgAutobid;